import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { SplitText } from 'components';
import { gsap, useGSAP } from 'src/utils/gsap';
import { prefersReducedMotion } from 'src/utils/motion';

import { usePage } from '../../pages';

import style from './Manifesto.module.scss';

const Manifesto = () => {
  const { t, i18n } = useTranslation('page');
  const { id } = usePage();
  const textRef = useRef(null);

  // Words light up one by one as you scroll
  useGSAP(
    () => {
      if (prefersReducedMotion) return;

      gsap.fromTo(
        textRef.current.querySelectorAll('.wi'),
        { opacity: 0.14 },
        {
          opacity: 1,
          stagger: 0.1,
          ease: 'none',
          scrollTrigger: { trigger: textRef.current, start: 'top 78%', end: 'bottom 40%', scrub: true }
        }
      );
    },
    { dependencies: [i18n.language], revertOnUpdate: true }
  );

  return (
    <section
      className={cn('sec tone-dark', style.manifesto)}
      data-tone='dark'
    >
      <div className={cn('wrap', style.inner)}>
        <p className='mono-label'>{t(`${id}.manifesto.label`)}</p>
        <div ref={textRef}>
          <SplitText
            as='p'
            className={style.text}
          >
            {t(`${id}.manifesto.textStart`)} <em>{t(`${id}.manifesto.textAccent`)}</em> {t(`${id}.manifesto.textEnd`)}
          </SplitText>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
